<template>
    <div>
        <!-- <base-alert type="warning" dismissible v-if="showBaseAlert">
            <div>
                {{ baseAlertText }}
                </div>
            </base-alert>
            <button @click="showBaseAlert = !showBaseAlert">OK</button>-->

        <!-- <router-link to="/logmonitoring/monitoringForm"> -->
        <!-- <router-link to="/logmonitoring/addmonitoringForm">
            <base-button type="info" class="addIndicatorBtn"
                >Monitoring Form</base-button
            ></router-link
        >
        <router-link to="/logmonitoring/reports">
            <base-button type="info" class="addIndicatorBtn"
                >Reports</base-button
            ></router-link
        > -->
        <div class="addIndicatorWrapper">
            <base-button
                @click="openModal()"
                type="primary"
                class="addIndicatorBtn"
                ><i class="el-icon-plus"></i>Add Indicator</base-button
            >
        </div>
        <modal
            class="modal alert"
            modalContentClasses="deleteModal"
            v-if="showAlert"
            :show.sync="showAlert"
            headerClasses="justify-content-center"
            >Are you sure to delete this indicator?<br />
            <base-button
                @click="deleteIndicator()"
                class="alert__button"
                type="info"
                >Yes</base-button
            >
            <base-button
                @click="showAlert = false"
                type="warning"
                class="alert__button"
                >No</base-button
            >
            <br />
            <div class="errorAlert">
                {{ deleteAlertText }}
            </div>
        </modal>
        <modal
            class="modal"
            v-if="showForm"
            :show.sync="showForm"
            headerClasses="justify-content-center"
        >
            <h3 v-if="!isUpdate">Add Indicator</h3>
            <h3 v-if="isUpdate">Update Indicator</h3>

            <el-form
                ref="form"
                :model="form"
                label-width="120px"
                v-if="showForm"
                class="form"
            >
                <div
                    style="display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                    "
                >
                    <div class="select input">
                        Indicator Type :
                        <el-select
                            v-model="form.indicator_type"
                            placeholder="Select Indicator Type"
                            class="select__field"
                        >
                            <el-option
                                v-for="item in indicatorTypes"
                                :key="item.id"
                                :label="item.type"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="input">
                        Indicator ID :
                        <el-input
                            v-model="form.indicator_code"
                            placeholder="Indicator ID"
                            class=""
                        ></el-input>
                    </div>
                </div>
                <div class="input">
                    Indicator Name :
                    <el-input
                        v-model="form.indicator_name"
                        placeholder="Indicator Name"
                        class="input__field"
                    ></el-input>
                </div>

                <div class="input">
                    Metric :
                    <el-input
                        v-model="form.metric"
                        placeholder="Metric"
                        class="input__field"
                    ></el-input>
                    <div style="color: lightslategray">
                        If several metrics are to be entered, please use a comma
                        to separate them.
                    </div>
                </div>
                <div class="input">
                    Description :
                    <el-input
                        type="textarea"
                        maxlength="200"
                        show-word-limit
                        style="width: 430px"
                        :autosize="{ minRows: 2, maxRows: 4 }"
                        placeholder="Description"
                        v-model="form.description"
                        class="input__field"
                    >
                    </el-input>
                </div>
            </el-form>
            <div class="errorAlert">{{ baseAlertText }}</div>
            <base-button @click="addIndicator()" v-if="!isUpdate" type="info"
                >Submit</base-button
            >
            <base-button @click="updateIndicator()" v-if="isUpdate" type="info"
                >Update</base-button
            >
        </modal>
        <el-table
            :data="tableData"
            style="width: 100%"
            class="table"
            :default-sort="{ prop: 'indicatorCode', order: 'ascending' }"
        >
            <el-table-column
                prop="indicatorCode"
                label="Indicator ID"
                class="table__column"
                sortable
            >
            </el-table-column>
            <el-table-column
                prop="indicator"
                label="Indicator Name"
                class="table__column"
                sortable
            >
            </el-table-column>

            <el-table-column
                prop="type"
                label="Indicator Type"
                class="table__column"
                sortable
            >
            </el-table-column>
            <el-table-column
                prop="metric"
                label="Indicator Metric"
                class="table__column"
                sortable
            >
            </el-table-column>
            <el-table-column
                prop="description"
                label="Description"
                class="table__column"
                sortable
            >
            </el-table-column>
            <el-table-column label="" class="table__column">
                <template slot-scope="scope">
                    <!-- <i
                    class="el-icon-edit"
                        @click="handleEdit(scope.$index, scope.row)"
                        style="color:blue;font-size:larger;"
                        ></i> -->
                    <base-button
                        size="sm"
                        type="info"
                        @click="handleEdit(scope.$index, scope.row)"
                        class="table__button"
                        >Edit<i class="el-icon-edit"></i
                    ></base-button>
                    <base-button
                        size="sm"
                        type="warning"
                        @click="handleDelete(scope.$index, scope.row)"
                        class="table__button"
                        >Delete<i class="el-icon-delete"></i
                    ></base-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- {{this.tableData.length}} -->
        <div class="pagination-border">
            <base-pagination
                @input="getIndicators"
                class="pagination-no-border"
                v-model="pagination.current_page"
                :per-page="pagination.per_page"
                :total="pagination.total"
            >
            </base-pagination>
        </div>
    </div>
</template>
<style lang="scss">
.el-textarea__inner{
    min-height: 80px;
    max-height: 130px !important;
}
.deleteModal{
    transform: translateY(200px)  !important;
}
.modal {
    .modal-content {
        transform: translateY(-125px);
    }
}
</style>
<style scoped lang="scss">
.pagination-border {
    background-color: #0000003d;
    padding: 10px;
}
.errorAlert {
    color: red;
}
.table {
    margin-top: 10px;
    &__button {
        margin: 20px !important;
    }
    &__column {
        text-align: center !important;
    }
}
.addIndicatorWrapper {
    padding: 20px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    .addIndicatorBtn {
        transform: translateY(-3px);
        color: #90c14f;
        background: #f5f6fa !important;
    }
}

.alert {
    min-height: 25vh;
    color: rgba(34, 42, 66, 0.7);
    padding: 30px;
    &__button {
        margin: 10px;
        margin-left: auto;
    }
}

.form {
    //     display: grid;
    // grid-template-columns: repeat(3, 1fr);
    // grid-template-rows: repeat(3, 1fr);
    // grid-column-gap: 0px;
    // grid-row-gap: 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    // gap:5;
    .input {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 10px;

        &__field {
            // max-width: 500px;
            // max-width: 30vw;
            width: 430px;
        }
    }
    .select {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 10px;
        &__field {
            max-width: 30vw;
            border-color: 1px solid;
        }
    }
}
// .btn:not(:disabled):not(.disabled) {
//     margin: 10px;
// }
</style>
<script>
import { LogMonitoringService } from "@/services";
import { Table, TableColumn, Select, Option, Pagination } from "element-ui";
import { Modal, BaseAlert, BasePagination } from "src/components";
export default {
    name: "indicator-form",
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        Modal,
        BaseAlert,
        BasePagination,
        [Select.name]: Select,
        [Option.name]: Option,
        Pagination,
    },
    data() {
        return {
            showForm: false,
            showAlert: false,
            showBaseAlert: false,
            deleteAlertText: "",
            baseAlertText: "",
            deleteID: "",
            isUpdate: false,
            tableData: [],
            page: 1,
            indicatorTypes: [],
            pagination: {
                current_page: 1,
                per_page: 10,
                total: 10,
            },
            form: {
                id: "",
                indicator_code: "",
                indicator_name: "",
                application_id: "",
                indicator_type: "",
                metric: "",
                result: "",
                baseline: "",
                target: "",
                baseline_comment: "",
                target_comment: "",
                means_of_verification: "",
                indicator_reference: "",
                created_at: "",
                updated_at: "",
                deleted_at: "",
                description: "",
            },

            form2: {
                Grant_ID: "",
                // ISO3(or country long name):"",
                ISO3: "",
                Region: "",
                Indicator_ID: "",
                Indicator_name: "",
                Baseline_value: "",
                Baseline_metric: "",
                Final_value: "",
                Final_metric: "",
            },
        };
    },
    methods: {
        setPage(val) {
            this.page = val;
        },
        onSubmit() {
            console.log("submit!");
        },
        openModal() {
            this.form.indicator_code = "";
            this.form.indicator_name = "";
            this.form.metric = "";
            this.form.indicator_type = "";
            this.showForm = !this.showForm;
            this.isUpdate = false;
            this.form.description = "";
            this.baseAlertText = "";
        },
        async getIndicators(page) {
            let page_to_get = page || this.pagination.current_page;
            await LogMonitoringService.getIndicators({
                page: page_to_get,
                per_page: this.pagination.per_page,
            }).then((response) => {
                this.tableData = response.data.data.data;
                this.pagination.total = response.data.data.total;
                // console.log(this.tableData);
            });
        },
        async getIndicatorTypes() {
            await LogMonitoringService.getIndicatortypes().then((response) => {
                this.indicatorTypes = response.data.data;
                console.log(this.indicatorTypes);
            });
        },
        async addIndicator() {
            if (
                this.form.indicator_code == "" ||
                this.form.metric == "" ||
                this.form.indicator_type == "" ||
                this.form.indicator_name == ""
            ) {
                this.baseAlertText =
                    "Please input all fields before submission";
                console.log("No data");
                return;
            }
            const data = {
                indicator_code: this.form.indicator_code,
                indicator: this.form.indicator_name,
                indicator_type_id: this.form.indicator_type,
                metric: this.form.metric,
                description: this.form.description,
            };
            await LogMonitoringService.addIndicator(data)
                .catch((response) => {
                    this.baseAlertText =
                        "The indicator ID has already been taken.";
                    // this.showBaseAlert = true;
                    // alert(this.baseAlertText);
                })
                .then((response) => {
                    console.log(response);
                    if (response.error) {
                        this.baseAlertText = response.error;
                        this.showBaseAlert = true;
                    }
                    this.form.indicator_code = "";
                    this.form.indicator_name = "";
                    this.form.metric = "";
                    this.form.description = "";
                    this.form.indicator_type = "";
                    this.showForm = false;
                    this.getIndicators();
                    console.log("Added indicator");
                });
        },
        async updateIndicator() {
            // if (
            //     this.form.indicator_code == "" ||
            //     this.form.indicator_name == ""
            // ) {
            //     console.log("No data");
            //     return;
            // }
            if (
                this.form.indicator_code == "" ||
                this.form.metric == "" ||
                this.form.indicator_type == "" ||
                this.form.indicator_name == ""
            ) {
                this.baseAlertText =
                    "Please input all fields before submission";
                console.log("No data");
                return;
            }
            const data = {
                id: this.form.id,
                indicator_code: this.form.indicator_code,
                indicator: this.form.indicator_name,
                indicator_type_id: this.form.indicator_type,
                metric: this.form.metric,
                description: this.form.description,
            };
            await LogMonitoringService.updateIndicator(data).then(
                (response) => {
                    console.log(response);
                    this.form.indicator_code = "";
                    this.form.indicator_name = "";
                    this.form.indicator_type = "";
                    this.form.description = "";
                    this.form.metric = "";
                    this.showForm = false;
                    this.isUpdate = false;
                    this.getIndicators();
                    console.log("Updated indicator");
                }
            );
        },
        async handleEdit(index, row) {
            console.log("Index : ", index);
            console.log("Row : ", row.id);

            await LogMonitoringService.getIndicator(row.id).then((response) => {
                this.getIndicators();
                console.log(response);
                this.form.id = response.data.data.id;
                this.form.indicator_code = response.data.data.indicatorCode;
                this.form.indicator_name = response.data.data.indicator;
                this.form.indicator_type = response.data.data.indicatorTypeId;
                this.form.description = response.data.data.description;
                this.form.metric = response.data.data.metric;
                this.isUpdate = true;
                this.showForm = true;
            });
        },
        async handleDelete(index, row) {
            this.deleteAlertText = "";

            this.deleteID = row.id;
            this.showAlert = true;
        },
        async deleteIndicator() {
            await LogMonitoringService.deleteIndicator({
                id: this.deleteID,
            }).then((response) => {
                console.log(response);
                if (
                    response.data.warning ===
                    "This indicator used in an application cannot be deleted."
                ) {
                    this.deleteAlertText =
                        "This indicator is used in an application and cannot be deleted.";
                } else {
                    this.showAlert = false;
                    this.getIndicators();
                }
            });
        },
    },
    mounted() {
        this.getIndicators();
        this.getIndicatorTypes();
    },
};
</script>
